import { ApiBase } from '../Implementation/ApiBase';
export class ExportInternalApi extends ApiBase {
    /**
     * Whether given data change affects given report
     * @param cellDataChangedInfo data change to check
     * @param report report to check
     */
    isDataChangeInReport(cellDataChangedInfo, report) {
        // for All Data Report any data change is true so get out asap
        if (report.Name == 'All Data') {
            return true;
        }
        // if its a Custom Report then the User has to run it so we just ignore completely
        if (this.getExportApi().isExternalReport(report)) {
            return false;
        }
        // Start with the DataChanged Column and go through all possibilities
        switch (report.ReportColumnScope) {
            case 'AllColumns':
                // has to be relevant so continue to rows
                break;
            case 'ScopeColumns':
                // use the Scope object which will tell us if the Column is relevant
                if (!this.getAdaptableApi().columnScopeApi.isColumnInScopeColumns(cellDataChangedInfo.column, report.Scope)) {
                    return false;
                }
                break;
            case 'SelectedColumns':
                let selectedCellInfo = this.getAdaptableApi().gridApi.getSelectedCellInfo();
                if (selectedCellInfo) {
                    if (selectedCellInfo.columns.find((c) => c.columnId == cellDataChangedInfo.column.columnId) == null) {
                        return false;
                    }
                }
                break;
            case 'VisibleColumns':
                //  hope that visibile column property is updated whenever the layout changes... (need to check!)
                if (!cellDataChangedInfo.column.visible) {
                    return false;
                }
                break;
        }
        // now do rows
        switch (report.ReportRowScope) {
            case 'AllRows':
                return true;
            case 'ExpressionRows':
                return true; // TODO this is the only difficult one - do we check AdapTableQL?  if we can then that is good as we can then do a delta after all...
            case 'SelectedCellRows':
                let selectedCellInfo = this.getAdaptableApi().gridApi.getSelectedCellInfo();
                if (selectedCellInfo && selectedCellInfo.gridCells) {
                    if (selectedCellInfo.gridCells.find((gc) => gc.primaryKeyValue == cellDataChangedInfo.primaryKeyValue)) {
                        return true;
                    }
                }
                return false;
            case 'SelectedRows':
                let selectedRowInfo = this.getAdaptableApi().gridApi.getSelectedRowInfo();
                if (selectedRowInfo && selectedRowInfo.gridRows) {
                    if (selectedRowInfo.gridRows.find((gr) => gr.primaryKeyValue == cellDataChangedInfo.primaryKeyValue)) {
                        return true;
                    }
                }
                return false;
            case 'VisibleRows':
                return this.adaptable.isRowNodeVisible(cellDataChangedInfo.rowNode);
        }
    }
    getExcelDataType(adaptableColumnType) {
        const mapColumnTypeToExcelType = (columnType) => {
            switch (columnType) {
                case 'abColDefNumber':
                    return 'Number';
                case 'abColDefBoolean':
                    return 'Boolean';
                case 'abColDefDate':
                    return 'DateTime';
                case 'abColDefString':
                default:
                    return 'String';
            }
        };
        if (Array.isArray(adaptableColumnType)) {
            const validColumnType = adaptableColumnType.find((colType) => colType.startsWith('abColDef'));
            if (!validColumnType) {
                return 'String';
            }
            return mapColumnTypeToExcelType(validColumnType);
        }
        else {
            return mapColumnTypeToExcelType(adaptableColumnType);
        }
    }
    isVisualDataExportInProgress() {
        return this.getAdaptableState().System.Export.visualDataExportInProgress;
    }
    isDateCellExportedAsFormattedValue(abColumn) {
        return (!!this.getExportOptions().exportDateFormat ||
            this.getCellExportFormatType(abColumn, 'Date') === 'formattedValue');
    }
    getCellExportFormatType(column, columnDataType) {
        const exportOptions = this.getExportOptions();
        const exportFormatType = exportOptions.exportFormatType;
        // First check if a function was provided and return the result
        if (exportFormatType != null && typeof exportFormatType === 'function') {
            const context = Object.assign(Object.assign({}, this.getAdaptableApi().internalApi.buildBaseContext()), { column: column });
            return exportFormatType(context);
        }
        // Next Check if a "hard-coded" value has been provided and return that
        if (exportFormatType === 'rawValue') {
            return 'rawValue';
        }
        if (exportFormatType === 'formattedValue') {
            return 'formattedValue';
        }
        // Finally test if a DataType object has been provided and return the relevant property
        const dataFormatDataType = exportFormatType;
        if (dataFormatDataType) {
            // format is customized based on column data type
            switch (columnDataType) {
                case 'String':
                    return dataFormatDataType.string;
                case 'Number':
                    return dataFormatDataType.number;
                case 'Date':
                    return dataFormatDataType.date;
                default:
                    // default to rawValue for all other column types
                    return 'rawValue';
            }
        }
        return 'rawValue';
    }
    isDestinationEnabled(destination) {
        if (destination === 'Table' && this.getLayoutApi().internalApi.isLayoutGrouped()) {
            return false;
        }
        return true;
    }
    getExcelStylesForVisualDataExport(original_excelStyles) {
        return [];
    }
}
